// src/AppWrapper.tsx
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { markAsRehydrated } from "./store/slices/authSlice";

const AppWrapper = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const { rehydrated } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!rehydrated) {
      // Mark as rehydrated since preloadedState already handles initialization
      dispatch(markAsRehydrated());
    }
  }, [dispatch, rehydrated]);

  return <>{children}</>;
};

export default AppWrapper;
